import React, { useEffect, useState } from 'react';
import { UseFormMethods } from 'react-hook-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import Restriction from 'src/models/leasehold/Restriction';

const REST_CATEGORY = [
    { value: 'Notification Requirement', label: 'Notification Requirement' },
    { value: 'Construction Requirement', label: 'Construction Requirement' },
];

interface IRestrictionListProps extends Partial<Pick<UseFormMethods, 'getValues' | 'setValue' | 'register' | 'errors'>> {
    restrictions: Array<Restriction>;
    namePrefix: string;

    handleRemoveRestrictions?: (index: number) => void;
    onAddRestriction: () => void;
}

const RestrictionList = (props: IRestrictionListProps) => {
    const [restrictions, setRestrictions] = useState<Array<Restriction>>([]);

    useEffect(() => {
        setRestrictions(props.restrictions ?? []);
    }, [props.restrictions]);

    return (
        <div>
            {restrictions?.length > 0 ? restrictions.map((restriction: Restriction, index: number) => {
                return (
                    <div className="form-row" key={`extension-${index}`}>
                        <div className="mr-1" hidden={true}>
                            <RHFInputBox label="" name={`${props.namePrefix}[${index}].id`} register={props.register} errors={props.errors} disabled={true} />
                            <RHFInputBox label="" name={`${props.namePrefix}[${index}].contractLookupId`} register={props.register} errors={props.errors} disabled={true} />
                            <RHFInputBox label="" name={`${props.namePrefix}[${index}].createdByUserId`} register={props.register} errors={props.errors} disabled={true} />
                            <RHFInputBox label="" name={`${props.namePrefix}[${index}].modifiedByUserId`} register={props.register} errors={props.errors} disabled={true} />
                            <RHFInputBox label="" name={`${props.namePrefix}[${index}].createdDate`} register={props.register} errors={props.errors} disabled={true} />
                        </div>
                        <RHFInputBox
                            label="No"
                            name={`${props.namePrefix}[${index}].no`}
                            register={props.register}
                            type="number"
                            errors={props.errors}
                            disabled={true}
                            bodyStyle={{ width: '5%' }}
                            style={{ width: '100%' }}
                        />
                        <RHFSelect
                            label="Category"
                            name={`${props.namePrefix}[${index}].category`}
                            options={REST_CATEGORY}
                            register={props.register}
                            errors={props.errors}
                            bodyStyle={{ width: '10%' }}
                            style={{ width: '100%' }}
                        />

                        <RHFInputBox 
                            label="Modified" 
                            name={`${props.namePrefix}[${index}].modifiedDate`} 
                            register={props.register}
                            errors={props.errors} 
                            bodyStyle={{ width: '10%' }}
                            style={{ width: '100%' }}
                            disabled={true} 
                        />
                        
                        <RHFInputBox
                            label="Description"
                            name={`${props.namePrefix}[${index}].note`}
                            register={props.register}
                            errors={props.errors}
                            bodyStyle={{ width: '70%' }}
                            style={{ width: '100%' }}
                        />

                        <div style={{ width: '5%' }}>
                            <button
                                type="button"
                                onClick={() => props.handleRemoveRestrictions?.(index)}
                                style={{ cursor: 'pointer', color: '#c23030', marginLeft: '1rem', fontWeight: 'bold', background: 'transparent', border: 'none' }}
                                title="Remove"
                                aria-label="Remove restrictions row"
                            >                                    
                                ×
                            </button>
                        </div>
                    </div>
                );
            }) : <div />}
            <div style={{ marginTop: '2rem' }}>
                <Button text="Add Restrictions" onClick={props.onAddRestriction} intent="primary" />
            </div>
        </div>
    );
};

export default RestrictionList;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/RestrictionList.tsx